const translations = {
  "footer.aboutUs": "ჩვენ შესახებ",
  "footer.career": "კარიერა",
  "footer.financialData": "ფინანსური ინფორმაცია",
  "footer.moreAboutInsurance": "გაიგე მეტი დაზღვევაზე",
  "footer.offices": "ოფისები",
  "footer.feedback": "უკუკავშირი",
  "footer.address": "ანა პოლიტკოვსკაიას ქ. #9",
  "footer.ourTeam": "ჩვენი გუნდი",
  "footer.legalInformation": "იურიდიული ინფორმაცია",
  "footer.onlineCenter": "ონლაინ დახმარება",
  "footer.contact": "კონტაქტი",

  "main.callUs": "დაგვირეკეთ",
  "main.messageUs": "მოგვწერეთ",

  "myProfile.insured": "დაზღვეული",
  "myProfile.children": "შვილები",
  "myProfile.parent": "მშობელი",
  "myProfile.addChild": "დაამატე შვილი",
  "myProfile.checkProfile": "პროფილის ნახვა",
  "myProfile.changePassword": "პაროლის შეცვლა",
  "myProfile.authorisationParameters": "ავტორიზაციის პარამეტრები",
  "myProfile.exit": "გამოსვლა",
  "myProfile.persNumber": "პირადი ნომერი",
  "myProfile.birthDate": "თვე/დღე/წელი",
  "myProfile.childAgeWarningText": `შვილის დამატება შეუძლებელია. შესაძლებელია მხოლოდ იმ პირის დამატება, რომლის ასაკიც არ აღემატება 14 წელს`,
  "myProfile.ageLaw":
    "პაციენტის უფლებების შესახებ კანონის მოთხოვნების დაცვის მიზნებისთვის, თქვენ შეძლებთ მხოლოდ იმ პირის დამატებას, რომლის ასაკიც არ აღემატება 14 წელს",
  "myProfile.smsForInsurer":
    "SMS გაიგზავნება ბავშვის დამზღვევის ტელეფონის ნომერზე",
  "myProfile.next": "შემდეგი",
  "myProfile.addManually": "მანუალურად დამატება",
  "myProfile.pleaseEnter1": "გთხოვთ მიუთითოთ",
  "myProfile.pleaseEnter2": "ნომერზე გამოგზავნილი SMS კოდი",
  "myProfile.smsCode": "SMS კოდი",
  "myProfile.addChildOtpIncorrect": "SMS კოდი არასწორია",
  "myProfile.againCode": "SMS კოდის ხელახლა გაგზავნა",
  "myProfile.addedSuccess": "ბავშვის პროფილი წარმატებით დაემატა!",
  "myProfile.pleaseCheckProfile": "გთხოვ, იხილო “ჩემი პროფილი”",
  "myProfile.oldPassword": "ძველი პაროლი",
  "myProfile.newPassword": "ახალი პაროლი",
  "myProfile.repeatPassword": "გაიმეორე პაროლი",
  "myProfile.save": "შენახვა",

  "breadCrumb.portal": "მთავარი გვერდი",
  "breadCrumb.service-center": "სერვის ცენტრში ჩაწერა",
  "breadCrumb.account": "ჩემი პროფილი",
  "breadCrumb.policy": "ჩემი პოლისები",
  "breadCrumb.providers": "პროვაიდერი კლინიკები და შეთავაზებები",
  "breadCrumb.travel": "სამოგზაურო დაზღვევა",
  "breadCrumb.questionary": "კითხავარი",
  "breadCrumb.med-history": "ჩემი სამედიცინო ისტორია",
  "breadCrumb.compensations": "თანხის ანაზღაურება",
  "breadCrumb.personal-doctor": "პირადი ექიმი",
  //temporary addition
  "breadCrumb.appeals": "მიმართვები",
  "breadCrumb.hospitalGuarantee": "ჰოსპიტალური გარანტია",
  "breadCrumb.profile-doctor": "ექიმთან ჩაწერა",
  "myProfile.myProfile": "ჩემი პროფილი",
  "myProfile.myIncurence": "ჩემი დაზღვევა",
  "myProfile.myPolicies": "ჩემი პოლისები",
  "myProfile.myMedHistory": "ჩემი სამედიცინო ისტორია",
  "myProfile.myProvClinics": "ჩემი პროვაიდერი კლინიკები",
  "myProfile.appointmentDoctor": "ექიმთან ჩაწერა",
  "myProfile.remoteServices": "დისტანციური მომსახურებები",
  "myProfile.appeals": "მიმართვები",
  "myProfile.moneyRefund": "თანხის ანაზღაურება",
  "myProfile.bookingServiceCenter": "სერვის ცენტრში ჩაწერა",
  "myProfile.insuranceProducts": "სადაზღვევო პროდუქტები",
  "myProfile.travelInsurance": "სამოგზაურო დაზღვევა",

  "profileMain.activeOffers": "აქტიური შეთავაზებები",
  "profileMain.offerDescription": "შეთავაზების აღწერა",
  "profileMain.seeAll": "ყველას ნახვა",
  "profileMain.startIncurance1": "ჩაეწერე",
  "profileMain.startIncurance2": "ოჯახის ექიმთან",
  "profileMain.startIncurance3": "ჩატ-ბოტით",
  "profileMain.startIncurance4": "მესენჯერიდანვე",
  "profileMain.currentAppeals": "მიმდინარე მიმართვები",
  "profileMain.extendAppeal": "ვადის გაგრძელება",
  "profileMain.validUntil": "მოქმედების ვადა",
  "profileMain.refunds": "ანაზღაურების მოთხოვნები",
  "profileMain.scheduledConsultations": "დაგეგმილი კონსულტაციები",
  "profileMain.myDoctor": "ჩემი ექიმი",
  "profileMain.myManager": "ჩემი მენეჯერი",
  "profileMain.validityPeriod": "მოქმედების ვადა",
  "profileMain.until": "-მდე",
  "profileMain.active": "აქტიური",
  "profileMain.appealNo": "მიმართვის ნომერი",
  "profileMain.policyNo": "პოლისის ნომერი",
  "profileMain.appealType": "მიმართვის ტიპი",
  "profileMain.policyService": "პოლისის სერვისი",
  "profileMain.medicalService": "სამედიცინო მომსახურება",
  "profileMain.medicamentName": "მედიკამენტი",
  "profileMain.quantity": "რაოდენობა",
  "profileMain.amount": "თანხა",
  "profileMain.providerClinic": "პროვაიდერი კლინიკა",
  "profileMain.insuranceShare": "სადაზღვევო წილი",
  "profileMain.barcode": "მიმართვის შტრიხკოდი",
  "profileMain.uploadedDoc": "ატვირთული სამედიცინო დოკ.",
  "profileMain.file": "ფაილი",
  "profileMain.correctComment": "კორექტირების კომენტარი",
  "profileMain.createDate": "შექმნის თარიღი",
  "profileMain.specialist": "სპეციალისტი",
  "profileMain.recommendPasswordChange":
    "რეკომენდაციის სახით გატყობინებთ, რომ სასურველია პაროლის დაყენება.",
  "profileMain.yourMailIs1": "შენი ელექტრონული ფოსტის მისამართია",
  "profileMain.yourMailIs2":
    "თუ გსურს, რომ შეცვალო აღნიშნული მისამართი, გთხოვ, ეწვიო გვერდს “ჩემი პროფილი”",
  "profileMain.yourMailIs3":
    "თუ გსურს ელექტრონული ფოსტის მისამართის დამატება, გთხოვ, ეწვიო გვერდს “ჩემი პროფილი”",
  "profileMain.agree": "დადასტურება",
  "profileMain.back": "უკან",
  "profileMain.childRemoved1":
    "თქვენს პროფილზე დამატებულ ბავშვს შეუსრულდა 14 წელი",
  "profileMain.childRemoved2":
    "პაციენტის უფლებების შესახებ კანონის მოთხოვნების დაცვის მიზნებისთვის, თქვენ შეძლებთ მხოლოდ იმ პირის პროფილით სარგებლობას, რომლის ასაკიც არ აღემატება 14 წელს",
  "profileMain.childRemoved3": "დაზღვეული სარგებლობს ინდივიდუალური პროფილით: ",
  "profileMain.agreed": "გავეცანი",
  "profileMain.yes": "დიახ",
  "profileMain.no": "არა",
  "profileMain.logOutFromDevicesText":
    "მსურს პაროლის შეცვლის შემდეგ ყველა სხვა მოწყობილობიდან გამოსვლა",
  "profileMain.changePolicy": "შეცვალე პოლისი",
  "profileMain.consultationModalTitle": "გჭირდება სპეციალისტის კონსულტაცია?",
  "profileMain.consultationModal":
    "მხოლოდ რამდენიმე კლიკით მიიღე სმს მიმართვა ოფთალმოლოგის, დერმატოლოგის, ნევროლოგისა და სხვა სპეციალისტების კონსულტაციაზე",
  "profileMain.consultationModalUrl": "პორტალიდან",
  "profileMain.getItOnAppStore": "Get it on App Store And Google Play",
  "profileMain.reimbursementService": "ჩატარებული სამედიცინო მომსახურება",

  "profileMain.uploadDoc": "ასატვირთი დოკუმენტაცია",
  "profileMain.fileSizeTooBigText":
    "შენ მიერ ატვირთული დოკუმენტების მოცულობა აღემატება 100 მეგაბაიტს, გთხოვ შეამცირო მათი მოცულობა",
  "profileMain.send": "გაგზავნა",
  "profileMain.ConsiderTheSubmittedDocuments":
    "არ მაქვს მოთხოვნილი დოკუმენტი, განიხილეთ მის გარეშე",
  "profileMain.successResendingRemunerationRequest":
    "დოკუმენტაცია წარმატებით გაიგზავნა!",
  "profileMain.failedResendingRemunerationRequest1": "დაფიქსირდა შეცდომა!",
  "profileMain.failedResendingRemunerationRequest2":
    "გთხოვ, სცადე დოკუმენტაციის თავიდან ატვირთვა",
  "profileMain.wantToActivate": "მსურს გააქტიურება",
  "profileMain.later": "მოგვიანებით",
  "profileMain.dontAskAgain": "აღარ მკითხო",
  "profileMain.doYouWantBiometrics":
    "გსურს ბიომეტრიული ავტორიზაციის გააქტიურება?",
  "dashboardAppeals.requestNewAppeal":
    "მიმართვა ვერ გაგრძელდება. საჭიროების შემთხვევაში, მოითხოვე ახალი მიმართვა",
  "dashboardAppeals.ReferralIsActive": "მიმართვა უკვე აქტიურია",
  "dashboardAppeals.referralIsAlreadyExtended":
    "მიმართვის ვადა უკვე გადაგრძელებულია",
  "dashboardAppeals.cannotBeExtended": `სამწუხაროდ, მიმართვის ვადა ვერ გაგრძელდება! მიმართვა უკვე გამოყენებულია`,
  "dashboardAppeals.extensionDeadlineHasExpired":
    "სამწუხაროდ, მიმართვის გადაგრძელების ვადა ამოწურულია",
  "dashboardAppeals.deadlineCannotBeExtendedWithImmuneVacinations": `სამწუხაროდ, იმუნიზაცია/ვაქცინაციის სერვისით გაცემულ მიმართვებზე ვადა ვერ გადაგრძელდება`,
  "dashboardAppeals.serviceLimitHasExpired": `სამწუხაროდ, მიმართვის ვადა ვერ გაგრძელდება! პოლისზე ამოწურულია სერვისის ლიმიტი`,
  "dashboardAppeals.recordNotFound": "ჩანაწერი არ მოიძებნა",
  "dashboardAppeals.mainErrorMessage":
    "სამწუხაროდ, მიმართვის ვადა ვერ გაგრძელდება!",
  "dashboardAppeals.mainSuccessMessage": "მიმართვის ვადა წარმატებით გაგრძელდა!",
  "dashboardAppeals.guaranteeIsactive": "ჰოსპიტალური გარანტია აქტიურია",
  "dashboardAppeals.guaranteeIsextended":
    "ჰოსპიტალური გარანტია უკვე გადაგრძელებულია",
  "dashboardAppeals.guaranteeIsused": "ჰოსპიტალური გარანტია უკვე გამოყენებულია",
  "dashboardAppeals.guaranteeIsexpired":
    "ჰოსპიტალური გარანტიის გადაგრძელების ვადა ამოწურულია",
  "dashboardAppeals.policiesExpired":
    "ჯანმრთელობის დაზღვევის პოლისი ვადაგასულია",
  "dashboardAppeals.errorCommunicatingWithEmailSenderService":
    "სამწუხაროდ დაფიქსირდა ტექნიკური შეცდომა. სცადე მოგვიანებით",
  "dashboardAppeals.toAddressIsRequired":
    "სამწუხაროდ მიმართვის ვადის გადაგრძელება ვერ ხერხდება. გთხოვ, დაუკავშირდე კონტაქტ ცენტრს ნომერზე: (032) 292 22 22",
  "dashboardAppeals.hospitalGuaranteeExtendWasAsked":
    "ჰოსპიტალურ საგარანტიოზე ვადის გაგრძელების მოთხოვნა გაგზავნილია. გაითვალისწინე, რომ საგარანტიო გადაგრძელდება მაქსიმუმ 15 დღით და პასუხს მიიღებ სმს შეტყობინების  სახით",
};

export default translations;
